import { useBootstrapApiBase } from '@aibees/shared/api';
import { Icon } from '@aibees/shared/components';
import { creditUsageCostKeys } from '@aibees/shared/constants';
import { useCreditUsageItem } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreditRuleCoinProps as Props } from './types';

export const CreditRuleCoin = memo(({ className, icon, sx, type }: Props) => {
  const { credit } = useCreditUsageItem(type);
  const bootstrap = useBootstrapApiBase();

  // An action the backend has not priced yet has no key in the cost map, and
  // useCreditUsageItem collapses that to 0 — which would advertise the action as
  // free. Render nothing instead, and start showing the coin by itself once the
  // rate ships. A composite type needs every part priced, or the sum understates
  // the real charge.
  const cost = bootstrap.data?.cost;
  const isPriced =
    !!cost && creditUsageCostKeys(type).every((key) => key in cost);
  if (!isPriced) return null;

  return (
    <Styled.Wrapper
      className={classnames('CreditRuleCoin', className)}
      sx={mergeSx(SX.root, sx)}
    >
      <Styled.Chip
        variant="outlined"
        color="primary"
        size="small"
        label={
          <Box sx={SX.chipContent}>
            {credit} x
            <Icon size={14} name={icon ?? 'coin'} />
          </Box>
        }
      />
    </Styled.Wrapper>
  );
});

CreditRuleCoin.displayName = 'CreditRuleCoin';
